
export enum PROFILE_ID {
  SKY_CL_CHATBOT_ES = "sky_cl_chatbot_es",
  SKY_PE_CHATBOT_ES = "sky_pe_chatbot_es",
  SKY_CORPORATE_CL_CHATBOT_ES = "sky_corporate_cl_chatbot_es",
}

export enum PROFILE_ENVIRONMENT {
  DEVELOPMENT = "development",
  PRODUCTION = "production",
}
